/* ==========================================================================
   Skogstad Sport – produktsiden

   Egen fil, ikke theme.js, så Archetypes temaoppdateringer ikke overskriver
   arbeidet vårt. Lastes fra sections/product-recommendations.liquid, i den
   instansen som kjører intent=complementary – altså «Gjør plagget komplett».
   ==========================================================================

   Formål: vise komplementærvaren i SAMME farge som kunden ser på.

   Uten dette viser Shopify standardvarianten. Ser kunden på en brun dunjakke
   og får foreslått en ullgenser i tilfeldig farge, må hun selv oversette
   forslaget til et antrekk. Med fargematching ser hun settet.

   Vi bygger ikke om noe: Impulses produktkort bærer allerede variant-URL,
   variant-ID, variantbilde og fargenavn per farge. Dette er en
   aktiveringsjobb, ikke en ombygging.
   ========================================================================== */
(function () {
  'use strict';

  var SECTION = 'product-recommendations[data-intent="complementary"]';

  /* Samme regel som theme.js sin getImageSetName, og samme resultat som
     Shopifys handle-filter for disse verdiene: «Cedar Wood» → «cedar-wood». */
  function toHandle(value) {
    return String(value)
      .toLowerCase()
      .replace(/[^a-z0-9]+/g, '-')
      .replace(/^-+|-+$/g, '');
  }

  /* Fargen kunden ser på nå.

     Vi hardkoder bevisst IKKE opsjonsnavnet «Farge». I stedet samler vi alle
     valgte variantverdier og lar kortene selv avgjøre hvilken som treffer en
     fargeswatch. Størrelser som «M» eller «38» kan aldri treffe en
     fargeklasse, så det er trygt – og logikken holder hvis opsjonen en dag
     heter noe annet. Det er samme sprøhet som bildesettene har, der alt
     henger på at opsjonen heter nøyaktig «Farge». Den fellen gjentar vi ikke. */
  function selectedValues() {
    var values = [];
    document.querySelectorAll('.variant-input-wrap input:checked').forEach(function (input) {
      if (input.value) {
        values.push(toHandle(input.value));
      }
    });
    return values;
  }

  function cardRoot(el) {
    return el.closest('.grid__item') || el.parentElement;
  }

  /* Aktiverer én farge på ett kort. Speiler det Impulse selv gjør ved hover:
     bytter bakgrunnsbildet, flytter .is-active, og peker kortets lenke på
     variant-URL-en – så et klikk havner på riktig farge og ikke på
     standardvarianten. */
  function activate(swatch) {
    var root = cardRoot(swatch);
    if (!root) return;

    var variantId = swatch.getAttribute('data-variant-id');
    var variantImage = swatch.getAttribute('data-variant-image');
    if (!variantId) return;

    root.querySelectorAll('.grid-product__color-image, .color-swatch').forEach(function (el) {
      el.classList.remove('is-active');
    });

    var imageEl = root.querySelector('.grid-product__color-image--' + variantId);
    if (imageEl && variantImage) {
      imageEl.style.backgroundImage = 'url(' + variantImage + ')';
      imageEl.classList.add('is-active');
    }
    swatch.classList.add('is-active');

    var link = root.querySelector('a.grid-product__link');
    if (!link) return;

    link.setAttribute('href', swatch.getAttribute('href'));

    /* Lenkas tilgjengelige navn skal si hvilken farge den fører til. Uten
       dette hører en skjermleserbruker bare produktnavnet, mens bildet ved
       siden av har byttet farge – informasjon kun formidlet visuelt.
       Den synlige tittelen beholdes først i navnet, jf. WCAG 2.5.3
       Label in Name. */
    var title = root.querySelector('.grid-product__title');
    var colourName = swatch.querySelector('.visually-hidden');
    if (title && colourName) {
      link.setAttribute(
        'aria-label',
        title.textContent.trim() + ' – ' + colourName.textContent.trim()
      );
    }
  }

  function syncColours() {
    var section = document.querySelector(SECTION);
    if (!section) return;

    var values = selectedValues();
    if (!values.length) return;

    section.querySelectorAll('.grid-product__colors').forEach(function (group) {
      for (var i = 0; i < values.length; i++) {
        var match = group.querySelector('.color-swatch--' + values[i]);
        if (match) {
          activate(match);
          return;
        }
      }
      /* Ingen treff: kortet har ikke fargen kunden ser på. Da lar vi
         standardvarianten stå, som er det oppgaven ber om. */
    });
  }

  /* Kortene settes inn av theme.js etter en fetch mot anbefalings-API-et, så
     DOMContentLoaded er for tidlig. recommendations:loaded er Impulses egen
     hendelse, og den bærer intent – så vi reagerer bare på vår egen seksjon. */
  document.addEventListener('recommendations:loaded', function (event) {
    if (event.detail && event.detail.intent && event.detail.intent !== 'complementary') {
      return;
    }
    syncColours();
  });

  /* Bytter kunden farge på produktet, skal komplementærvarene følge etter.
     Vi lytter på change i bobleflyt framfor Impulses interne variantChange,
     som er navnerommet per seksjon og dermed skjørt å hekte seg på. */
  document.addEventListener('change', function (event) {
    var target = event.target;
    if (target && target.closest && target.closest('.variant-input-wrap')) {
      syncColours();
    }
  });
})();

/* ==========================================================================
   Sticky «Legg i handlekurv» på mobil (26.08.2026, PDP-analysen pkt. 26)

   Viser snippets/skogstad-sticky-atc.liquid når hovedknappen er scrollet ut
   av viewport, og speiler pris, valgt variant og utsolgt-tilstand fra
   hovedpanelet. Selve kjøpet går gjennom produktskjemaet (form-attributt på
   knappen), så Impulses ajax-kurv gjelder uendret.

   Vi leser pris fra DOM-en ([data-product-price]) i stedet for å formatere
   selv: theme.js har allerede oppdatert den når variant:change når oss – én
   requestAnimationFrame senere er vi garantert bak i køen.
   ========================================================================== */
(function () {
  'use strict';

  var bar = document.querySelector('[data-sticky-atc]');
  if (!bar || !('IntersectionObserver' in window)) { return; }

  var section = document.querySelector('[data-section-type="product"]');
  if (!section) { return; }

  var mainBtn = section.querySelector('[data-add-to-cart]');
  if (!mainBtn) { return; }

  var priceEl = bar.querySelector('[data-sticky-atc-price]');
  var variantEl = bar.querySelector('[data-sticky-atc-variant]');
  var stickyBtn = bar.querySelector('[data-sticky-atc-button]');

  /* Baren har to grunner til å være borte, og de er uavhengige:
     hovedknappen er synlig, ELLER antrekksmodulen er synlig.

     Den andre kom inn 21.09.2026 med sections/skogstad-pdp-antrekk.liquid.
     Modulen har sin egen primærknapp, «Legg valgte i handlekurven», og den
     legger til ANDRE plagg enn baren gjør. To utfylte knapper med ulik
     betydning samtidig på skjermen er ikke to tilbud, det er et spørsmål
     kunden ikke skal måtte stille seg — og den nederste vinner alltid
     oppmerksomheten. Så lenge antrekket er i syne, er det antrekket som
     eier kjøpshandlingen.

     To tilstander og én oppdatering, i stedet for at hver observer skriver
     til klassen: med to skrivere ville den som løp sist bestemt, og baren
     ville blinket tilbake når man scrollet forbi modulen. */
  var hovedSynlig = true;
  var antrekkSynlig = false;

  function oppdaterBar() {
    var skjul = hovedSynlig || antrekkSynlig;
    bar.classList.toggle('is-visible', !skjul);
    bar.setAttribute('aria-hidden', skjul ? 'true' : 'false');
  }

  var observer = new IntersectionObserver(function (entries) {
    hovedSynlig = entries[0].isIntersecting;
    oppdaterBar();
  }, { rootMargin: '-70px 0px 0px 0px' });
  observer.observe(mainBtn);

  /* Modulen rendres av anbefalingsruten og finnes ikke ved sidelast, så
     observeren kan først opprettes når theme.js har byttet inn innholdet.
     `once` er ikke satt: «Passer sammen med» og «Relevante produkter»
     sender den samme hendelsen, og vi må se den som faktisk er vår. */
  document.addEventListener('recommendations:loaded', function () {
    var antrekk = document.querySelector('.skogstad-antrekk--pdp');
    if (!antrekk || antrekk.dataset.skBarObservert) { return; }
    antrekk.dataset.skBarObservert = '1';

    new IntersectionObserver(function (entries) {
      antrekkSynlig = entries[0].isIntersecting;
      oppdaterBar();
    /* Halve modulen i syne er nok. Terskelen er der for at baren ikke skal
       forsvinne idet den øverste hårstreken akkurat kommer inn nederst i
       viewporten — da ville den blinket på og av mens kunden scrollet. */
    }, { threshold: 0.5 }).observe(antrekk);
  });

  function sync() {
    var mainPrice = section.querySelector('[data-product-price]');
    if (mainPrice && priceEl) {
      priceEl.textContent = mainPrice.textContent.trim();
    }

    if (variantEl) {
      var chosen = [];
      section.querySelectorAll('.variant-input-wrap input:checked').forEach(function (input) {
        // Trimit sender «7 Not in use» som størrelsesverdi. input.value må stå
        // urørt (Shopify matcher varianten på den), så suffikset strippes her,
        // i det ene steget som skriver verdien ut som lesbar tekst.
        chosen.push(String(input.value).replace(/\s*Not in use$/i, ''));
      });
      if (chosen.length) { variantEl.textContent = chosen.join(' / '); }
    }

    if (stickyBtn) {
      stickyBtn.disabled = mainBtn.disabled;
      var label = mainBtn.querySelector('[data-add-to-cart-text]');
      if (label && label.textContent.trim()) {
        stickyBtn.textContent = label.textContent.trim();
      }
    }
  }

  document.addEventListener('variant:change', function () {
    window.requestAnimationFrame(sync);
  });

  sync();
})();

/* ==========================================================================
   Størrelsesguide-sidepanelet (27.08)

   Åpnes fra [data-size-guide-open] (modellinfo-raden i kjøpsboksen på
   desktop, under hovedbildet på mobil). Lukkes med kryss, overlegg-klikk
   eller Escape. Fokus flyttes inn i panelet ved åpning og tilbake til
   knappen ved lukking; siden bak låses mot scrolling.
   ========================================================================== */
(function () {
  'use strict';

  var root = document.querySelector('[data-size-guide]');
  if (!root) {
    // Snippeten rendrer ikke panelet for OneSize-produkter – da skal
    // knappen heller ikke stå der og love noe som ikke finnes.
    document.querySelectorAll('[data-size-guide-open]').forEach(function (knapp) {
      knapp.hidden = true;
    });
    return;
  }

  var panel = root.querySelector('.skogstad-size-guide__panel');
  var sisteTrigger = null;

  function aapne() {
    root.hidden = false;
    window.requestAnimationFrame(function () {
      root.classList.add('is-open');
    });
    document.documentElement.classList.add('skogstad-size-guide-open');
    if (panel) { panel.focus(); }
  }

  function lukk() {
    root.classList.remove('is-open');
    document.documentElement.classList.remove('skogstad-size-guide-open');
    window.setTimeout(function () { root.hidden = true; }, 280);
    if (sisteTrigger) { sisteTrigger.focus(); }
  }

  document.addEventListener('click', function (event) {
    var trigger = event.target.closest('[data-size-guide-open]');
    if (trigger) {
      sisteTrigger = trigger;
      aapne();
      return;
    }
    if (!root.hidden && event.target.closest('[data-size-guide-close]')) {
      lukk();
    }
  });

  document.addEventListener('keydown', function (event) {
    if (event.key === 'Escape' && !root.hidden) {
      lukk();
    }
  });
})();
